function ContactButton({ type }) {
  const style = {
    position: "fixed",
    bottom: "20px",
    right: "26px",
    cursor: "pointer",
    zIndex: "1000",
    width: "50px",
    height: "50px",
    borderRadius: "50%",
    backgroundColor: "white",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
    transition: "all 0.3s ease-in-out",
    "&:hover": {
      transform: "scale(1.1)",
    },
  };

  const callStyle = {
    ...style,
    bottom: "96px",
  };

  if (type === "call") {
    return (
      <a
        href="tel:+966544085577"
        className="contact-button"
        style={callStyle}
        target="_blank"
        rel="noreferrer"
      >
        <span className="contact-tooltip">تواصل معنا عبر الهاتف</span>
        <img src="/img/call.png" alt="" width="58" />
      </a>
    );
  }

  return (
    <a
      href="https://wa.me/+966544085577"
      className="contact-button"
      style={style}
      target="_blank"
      rel="noreferrer"
    >
      {/* tooltip on hover */}
      <span className="contact-tooltip">تواصل معنا عبر الواتساب</span>
      <img src="/img/icons8-whatsapp.svg" alt="" width="64" />
    </a>
  );
}

export default ContactButton;
